/** Dark mark for light backgrounds */
export const CRONPAY_LOGO_DARK = '/asset/images/cronPayDark.png';
/** Light mark for dark backgrounds */
export const CRONPAY_LOGO_LIGHT = '/asset/images/cronPayLight.png';

/** @param {'light' | 'dark'} resolvedTheme */
export function cronpayLogoSrc(resolvedTheme) {
    return resolvedTheme === 'dark' ? CRONPAY_LOGO_LIGHT : CRONPAY_LOGO_DARK;
}
